/**
 * Форматированный вывод числа.
 * Добавляет пробелы разряда, кратного 3.
 * @param {number | string} amount
 * @returns {string}
 */
export function amountFormat(amount) {
    amount = amount + '';

    const dotIndex = amount.indexOf('.');
    const isNegative = amount.substr(0, 1) === '-';
    let int = dotIndex !== -1 ? amount.substr(0, dotIndex) : amount;
    let fractional = dotIndex !== -1 ? amount.substr(dotIndex + 1) : void 0;
    let i;

    if (isNegative) {
        int = int.substr(1);
    }

    if (fractional) {
        if (fractional.substr(2, 1) * 1 >= 5) {
            fractional = fractional
                .substr(0, 2)
                .replace(/^(.+?)(\d)$/, (a, b, c) => {
                    return b + (c * 1 + 1);
                });
        } else {
            fractional = fractional.substr(0, 2);
        }
    }

    const intArray = [];

    for (i = int.length - 3; i > -3; i -= 3) {
        intArray.unshift(int.substr(i < 0 ? 0 : i, i < 0 ? 3 + i : 3));
    }

    int = intArray.join('\u00A0');

    if (fractional) {
        int += '.' + fractional.substr(0, 2);
    }

    if (isNegative) {
        int = '-' + int;
    }

    return int;
}

export default amountFormat;
